<template>
    <div class="grid-manage-middle">
        <div class="nav">
            <div class="nav-item">
                <p>网格编号：</p>
                <!-- <el-input v-model="searchParams.gridCode" placeholder=""> </el-input> -->
                <el-select v-model="searchParams.gridCode" filterable placeholder="请选择">
                    <el-option
                        v-for="(item, index) in gridCodeList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="nav-item">
                <p>网格名称：</p>
                <!-- <el-input v-model="searchParams.name" placeholder=""> </el-input> -->
                <el-select v-model="searchParams.name" filterable placeholder="请选择">
                    <el-option
                        v-for="(item, index) in gridNameList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="nav-item">
                <p>网格状态：</p>
                <el-select style="width: 100%" v-model="searchParams.executeStatus" placeholder="全部">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="nav-item">
                <el-button type="primary" @click="searchFn">查询</el-button>
                <el-button type="primary" @click="resetFn">重置</el-button>
            </div>
        </div>
        <div class="grid-manage-map">
            <Render v-if="modules" :render="renderMap" />
        </div>
    </div>
</template>

<script>
import { Render } from '@CommonComponent';

export default {
    components: {
        Render,
    },
    inject: ['modules'],
    props: ['getGridList', 'gridList', 'areaId', 'getcurGridInfo', 'selectFn'],
    data() {
        return {
            options: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: 0,
                    label: '可飞',
                },
                {
                    value: 1,
                    label: '禁飞',
                },
                {
                    value: 2,
                    label: '停用',
                },
            ],
            searchParams: {
                gridCode: '',
                name: '',
                executeStatus: '',
            }, // 搜索的参数
            gridCodeList: [],
            gridNameList: [],
        };
    },
    watch: {
        gridList: {
            deep: true,
            handler(list) {
                this.gridCodeList = [];
                this.gridNameList = [];
                list.forEach((item) => {
                    let gridCode = {
                        label: item.gridCode,
                        value: item.gridCode,
                    };
                    let gridName = {
                        label: item.name,
                        value: item.name,
                    };
                    this.gridCodeList.push(gridCode);
                    this.gridNameList.push(gridName);
                });
            },
        },
    },

    methods: {
        renderMap() {
            return [this.modules.MixMapModule.output.default({})];
        },
        async searchFn() {
            let obj = {
                areaId: this.areaId,
            };
            let firstObj = await this.getGridList(Object.assign(this.searchParams, obj));
            console.log(firstObj[0], '=============');

            this.selectFn(firstObj[0]);
        },
        async resetFn() {
            this.searchParams = {
                areaId: this.areaId,
                gridCode: '',
                name: '',
                executeStatus: '',
            };
            let firstObj = await this.getGridList(this.searchParams);
            this.selectFn(firstObj[0]);
        },
    },
};
</script>

<style lang="scss" scoped>
.grid-manage-middle {
    height: 100%;
    flex: 1;
    padding: 10px;
    box-sizing: border-box;
    .nav {
        margin-bottom: 10px;
        display: flex;
        .nav-item {
            display: flex;
            margin-right: 30px;
            p {
                min-width: 80px;
                line-height: 30px;
            }
        }
    }
    .grid-manage-map {
        position: relative;
        background-color: #ccc;
        height: calc(100% - 32px);
    }
}
</style>
